import React from "react";
import { Tooltip } from "@mui/material";

export default function WithTooltip({ enabled, title, children }) {
  return (
    <Tooltip title={!enabled ? title : ""} arrow disableHoverListener={enabled}>
      <span style={{ width: "100%" }}>{children}</span>
    </Tooltip>
  );
}
